export class FactorSetData
{
    value:number;
    colId:number;
    rowId:number;
    factorSetId:number;
}